import "core-js/modules/es.object.to-string";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getStationDailyPlatformData } from '@/api/bairun/financialCenter';
import moment from 'moment';
import dateUtils from '@/utils/dateUtil';
export default {
  name: 'FinancialPlatformSold',
  data: function data() {
    var _this = this;

    return {
      datePickerValue: [(dateUtils.todayTimestamp() - 7 * 24 * 60 * 60) * 1000, (dateUtils.todayTimestamp() - 24 * 60 * 60) * 1000],
      downloadLoading: false,
      stationDailyPlatformData: [],
      sheetUnLoadCount: 1,
      selectedStation: {
        'ID': 0,
        'stationName': '',
        'statTag': '选择站点',
        'statAbbr': '',
        'appId': 'aaa'
      },
      excelSheets: [{
        tableId: 'stationDailyPlatformData',
        name: '平台月度销售报表',
        tableRows: 2
      }],
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  created: function created() {},
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs['stationDailyPlatformData'].doLayout(); // console.log('refsUpdate')

    });
  },
  methods: {
    loadData: function loadData() {
      var _this3 = this;

      // console.log('this.selectedStation', this.selectedStation)
      if (!this.selectedStation || !this.selectedStation.ID || parseInt(this.selectedStation.ID) < 1000) {
        _Message({
          message: '请筛选要查询的油站',
          type: 'error',
          duration: 2 * 1000
        });

        return;
      } // console.log(this.datePickerValue[1], this.datePickerValue[1] / 1000)


      if (this.datePickerValue[1] - this.datePickerValue[0] > 86400 * 31 * 1000) {
        _Message({
          message: '时间跨度不能超一个月',
          type: 'error',
          duration: 2 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      getStationDailyPlatformData({
        appId: 'xxx',
        sellerId: this.selectedStation.ID,
        startDate: moment(this.datePickerValue[0]).format('YYYYMMDD'),
        endDate: moment(this.datePickerValue[1]).format('YYYYMMDD')
      }).then(function (response) {
        // // console.log('getStationDailyDiff', response)
        _this3.stationDailyPlatformData = response.data;
        _this3.sheetUnLoadCount = 0;
        _this3.downloadLoading = false;
      });
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this4 = this;

      if (this.sheetUnLoadCount > 0) {
        _Message({
          message: '请查询核对过后进行下载',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (!this.selectedStation || !this.selectedStation.ID || parseInt(this.selectedStation.ID) < 1000) {
        _Message({
          message: '请筛选要查询的油站',
          type: 'error',
          duration: 2 * 1000
        });

        return;
      }

      if (this.stationDailyPlatformData.length === 0) {
        _Message({
          message: '无有效数据，请查询后下载',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      excelName += '--' + this.selectedStation.statTag;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, moment(_this4.datePickerValue[0]).format('YYYY年MM月DD日') + ' ~ ' + moment(_this4.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this4.downloadLoading = false;
      });
    }
  }
};